module.exports = __webpack_public_path__ + "static/media/successotoavatartwo.b670960c.png";